import { NAME_PROJECT } from "@/constants/labels";
import { EQUIPOS } from "@/interfaces/SmartLink/Equipos";
import store from "@/store";
import { computed } from "vue";
const projectName = computed(() => store.state.projectName);
const INTERVALINMINUTES = projectName.value === "SmartLinkDEMO" ? 15 : 1;
const INTERVALRAJANTMINUTES = projectName.value === "SmartLinkDEMO" ? 15 : 5;

// { fecha: string }[]
export function obtenerRangoFechas(datos: EQUIPOS[]) {
  let minTime = Infinity;
  let maxTime = -Infinity;

  for (const item of datos) {
    const time = new Date(item.fecha ?? "").getTime();
    if (time < minTime) minTime = time;
    if (time > maxTime) maxTime = time;
  }

  return {
    inicio: new Date(minTime).toISOString(),
    fin: new Date(maxTime).toISOString(),
  };
}

/* eslint-disable */
export function completarIntervalosTempVolt(
  datos: any[],
  inicio: string,
  fin: string,
  intervaloMin = INTERVALRAJANTMINUTES,
) {
  const resultado: EQUIPOS[] = [];

  const mapDatos = new Map<number, EQUIPOS>(
    datos.map((d) => [new Date(d.fecha ?? "").getTime(), d]),
  );

  const intervaloMs = intervaloMin * 60 * 1000;
  const inicioTime = new Date(inicio).getTime();
  const finTime = new Date(fin).getTime();

  for (let t = inicioTime; t <= finTime; t += intervaloMs) {
    const valuesFind = mapDatos.get(t);
    // const valores = mapDatos.has(t) ? mapDatos.get(t)! : `{"temperature": [0], "voltage": [0]}`;
    // const valores = mapDatos.get(t);
    resultado.push({
      fecha: new Date(t).toISOString(),
      valores: valuesFind
        ? valuesFind.valores
        : `{"temperature": [0], "voltage": [0]}`,
      anotacion: valuesFind ? valuesFind.anotacion : '{"model": "ES1-2450RE"}',
    });
  }

  return resultado;
}

export function completarIntervalosInstamesh(
  datos: EQUIPOS[],
  inicio: string,
  fin: string,
  intervaloMin = INTERVALRAJANTMINUTES,
) {
  const resultado: EQUIPOS[] = [];

  const mapDatos = new Map<number, EQUIPOS>(
    datos.map((d) => [new Date(d.fecha ?? "").getTime(), d]),
  );

  const intervaloMs = intervaloMin * 60 * 1000;
  const inicioTime = new Date(inicio).getTime();
  const finTime = new Date(fin).getTime();
  let defaultWireless = "";

  for (let t = inicioTime; t <= finTime; t += intervaloMs) {
    const valuesFind = mapDatos.get(t);
    if (t === inicioTime)
      defaultWireless = getWirelessDefault(valuesFind ?? {});
    resultado.push({
      fecha: new Date(t).toISOString(),
      wired: valuesFind
        ? valuesFind.wired
        : `{"eth0": {"rxBytes": 0, "txBytes": 0}, "cost": 0}`,
      wireless: valuesFind ? valuesFind.wireless : defaultWireless,
    });
  }

  return resultado;
}

function getWirelessDefault(value: EQUIPOS) {
  let finalString = "";
  const finalITEM = value.wireless ? JSON.parse(value.wireless) : "";

  finalITEM.wlan0
    ? (finalString =
        '{"wlan0": { "noise": 0, "rxBytes": 0, "txBytes": 0 }, "cost": 0}')
    : null;
  finalITEM.wlan1
    ? (finalString =
        '{"wlan0": { "noise": 0, "rxBytes": 0, "txBytes": 0 }, "wlan1": { "rxBytes": 0, "txBytes": 0 }, "cost": 0}')
    : null;
  finalITEM.wlan2
    ? (finalString =
        '{"wlan0": { "noise": 0, "rxBytes": 0, "txBytes": 0 }, "wlan1": { "rxBytes": 0, "txBytes": 0 }, "wlan2": { "rxBytes": 0, "txBytes": 0 }, "cost": 0}')
    : null;
  finalITEM.wlan3
    ? (finalString =
        '{"wlan0": { "noise": 0, "rxBytes": 0, "txBytes": 0 }, "wlan1": { "rxBytes": 0, "txBytes": 0 }, "wlan2": { "rxBytes": 0, "txBytes": 0 }, "wlan3": { "rxBytes": 0, "txBytes": 0 }, "cost": 0}')
    : null;

  return finalString;
}

export function completarIntervalosPMPSM(
  datos: EQUIPOS[],
  inicio: string,
  fin: string,
  intervaloMin = INTERVALINMINUTES,
) {
  const resultado: EQUIPOS[] = [];

  const mapDatos = new Map<number, EQUIPOS>(
    datos.map((d) => [new Date(d.fecha ?? "").getTime(), d]),
  );

  const intervaloMs = intervaloMin * 60 * 1000;
  const inicioTime = new Date(inicio).getTime();
  const finTime = new Date(fin).getTime();

  if (
    projectName.value === NAME_PROJECT.cananea ||
    projectName.value === NAME_PROJECT.demo ||
    projectName.value === NAME_PROJECT.nacozari
  ) {
    for (let t = inicioTime; t <= finTime; t += intervaloMs) {
      const valuesFind = mapDatos.get(t);
      resultado.push({
        fecha: new Date(t).toISOString(),
        snr: valuesFind ? valuesFind.snr : `{ "H": 0, "V": 0 }`,
      });
    }
  } else {
    for (let t = inicioTime; t <= finTime; t += intervaloMs) {
      const valuesFind = mapDatos.get(t);
      resultado.push({
        fecha: new Date(t).toISOString(),
        snr: valuesFind
          ? valuesFind.snr
          : `{"H": [0,0,0,0,0,0], "V": [0,0,0,0,0,0], "PER": 0}`,
        link_radio: valuesFind ? valuesFind.link_radio : `{ "tx": 0, "rx": 0 }`,
        throughput: valuesFind
          ? valuesFind.throughput
          : `{"inthroughputbytes": 0}`,
      });
    }
  }

  return resultado;
}

export function completarIntervalosSTATUS(
  datos: EQUIPOS[],
  inicio: string,
  fin: string,
  intervaloMin = INTERVALINMINUTES,
) {
  const resultado: EQUIPOS[] = [];

  const mapDatos = new Map<number, EQUIPOS>(
    datos.map((d) => [new Date(d.fecha ?? "").getTime(), d]),
  );

  const intervaloMs = intervaloMin * 60 * 1000;
  const inicioTime = new Date(inicio).getTime();
  const finTime = new Date(fin).getTime();

  for (let t = inicioTime; t <= finTime; t += intervaloMs) {
    const valuesFind = mapDatos.get(t);
    resultado.push({
      fecha: new Date(t).toISOString(),
      status: valuesFind ? valuesFind.status : `"down"`,
      ip: "",
    });
  }

  return resultado;
}

export function completarIntervalosLatency(
  datos: EQUIPOS[],
  inicio: string,
  fin: string,
  intervaloMin = INTERVALINMINUTES,
) {
  const resultado: EQUIPOS[] = [];

  const mapDatos = new Map<number, EQUIPOS>(
    datos.map((d) => [new Date(d.fecha ?? "").getTime(), d]),
  );

  const intervaloMs = intervaloMin * 60 * 1000;
  const inicioTime = new Date(inicio).getTime();
  const finTime = new Date(fin).getTime();

  for (let t = inicioTime; t <= finTime; t += intervaloMs) {
    const valuesFind = mapDatos.get(t);
    resultado.push({
      fecha: new Date(t).toISOString(),
      kpi: valuesFind ? valuesFind.kpi : -1,
    });
  }

  return resultado;
}
